<template>
  <div class="site-frame home-page">
    <section class="home-intro">
      <div>
        <h1>Know what’s out there.</h1>
        <p class="home-lead">
          Check overseas stock reports and NPC loot timers before your next
          move. Prometheus is built by Torn players, for Torn players.
        </p>
        <div class="home-actions">
          <router-link class="button button-primary" to="/travel"
            >Check foreign stocks <ArrowRight :size="18" aria-hidden="true"
          /></router-link>
          <router-link class="button button-secondary" to="/npc-loot"
            >View NPC loot</router-link
          >
        </div>
      </div>
      <div class="home-board" aria-label="What Prometheus tracks">
        <div class="board-heading">
          <span>Prometheus / field guide</span>
        </div>
        <router-link to="/travel" class="board-row"
          ><span
            ><strong>Foreign stocks</strong
            ><small
              >Destinations · observed stock · restock estimates</small
            ></span
          ><ArrowUpRight :size="19" aria-hidden="true"
        /></router-link>
        <router-link to="/npc-loot" class="board-row"
          ><span
            ><strong>NPC loot</strong
            ><small>Loot levels · countdowns · rewards</small></span
          ><ArrowUpRight :size="19" aria-hidden="true"
        /></router-link>
        <router-link to="/commands" class="board-row"
          ><span
            ><strong>Discord bot</strong
            ><small>Commands and community tools</small></span
          ><ArrowUpRight :size="19" aria-hidden="true"
        /></router-link>
      </div>
    </section>
    <section class="home-explainer">
      <div>
        <h2>Reports from the community</h2>
        <p>
          Foreign stock reports come from players and integrations, including
          <a
            href="https://www.torn.com/forums.php#/p=threads&amp;f=67&amp;t=16163503&amp;b=0&amp;a=0"
            target="_blank"
            rel="noopener noreferrer"
            >Torn PDA</a
          >
          and
          <a
            href="https://www.torn.com/forums.php#/p=threads&amp;f=67&amp;t=16243863&amp;b=0&amp;a=0"
            target="_blank"
            rel="noopener noreferrer"
            >TornTools</a
          >. Check when a country was last observed before
          relying on its quantities.
        </p>
      </div>
      <div>
        <h2>From IRC to Discord</h2>
        <p>
          Prometheus began as a Torn IRC bot around 2007 and continued on
          Discord in 2018. The project still serves players looking for useful
          game information and a place to share it.
        </p>
        <router-link class="text-link" to="/join"
          >Meet the community <ArrowRight :size="17" aria-hidden="true"
        /></router-link>
      </div>
    </section>
  </div>
</template>

<script>
import { ArrowRight, ArrowUpRight } from "lucide-vue";
export default { name: "Home", components: { ArrowRight, ArrowUpRight } };
</script>
